import { render, staticRenderFns } from "./PlanItemsTable.vue?vue&type=template&id=106bfd1f&scoped=true"
import script from "./PlanItemsTable.vue?vue&type=script&lang=js"
export * from "./PlanItemsTable.vue?vue&type=script&lang=js"
import style0 from "./PlanItemsTable.vue?vue&type=style&index=0&id=106bfd1f&prod&lang=scss&scoped=true"
import style1 from "./PlanItemsTable.vue?vue&type=style&index=1&id=106bfd1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bfd1f",
  null
  
)

export default component.exports